/* eslint-disable @next/next/link-passhref */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, withStyles } from '@material-ui/core';

import formatDate from '@lc/lib/helpers/formatDate';
import routes from '@lc/lib/routes';
import Button from '@lc/ui/components/Button';
import { useProvider } from '@lc/lib/Provider';

import ChatIcon from 'public/images/icons/chat_blue.svg';
import styles from './ChatContact.style';

// eslint-disable-next-line no-unused-vars
const ChatContact = ({
  classes,
  profile,
  room,
  IAMBooker,
  IAMHoster,
  bookingId,
  onClick,
  btnId,
}) => {
  const { t } = useTranslation(['chats']);
  const {
    user: { isLogged },
  } = useProvider();

  const completeName = `${profile.user.first_name} ${profile.user.last_name}`;
  const firstName = profile.user.first_name;
  const sinceDate = formatDate(room.created_at, 'MMMM [de] YYYY');
  const userSinceDate = formatDate(profile.user.created_at, 'MMMM [de] YYYY');

  const openChat = () => {
    Router.replace(
      `${routes.internal.openChat(
        IAMBooker ? 'booker' : 'hoster',
        IAMBooker ? room.id : bookingId,
      )}${!isLogged ? '&quickRegister=1' : ''}`,
    );
  };

  return (
    <Grid container spacing={0} direction="column" className={classes.chatContactWrapper}>
      <Typography className={classes.title}>{completeName}</Typography>
      <Typography className={classes.text}>
        {IAMHoster
          ? t('roomSince', { name: firstName, date: sinceDate })
          : t('userSince', { name: firstName, date: userSinceDate })}
      </Typography>
      <Button
        id={btnId}
        naked
        noPadding
        onClick={() => {
          onClick();
          openChat();
        }}
      >
        <Typography className={classes.link}>
          {t('talkTo')} {firstName}
          <ChatIcon className={classes.icon} />
        </Typography>
      </Button>
    </Grid>
  );
};

ChatContact.propTypes = {
  classes: PropTypes.object.isRequired,
  IAMBooker: PropTypes.bool,
  IAMHoster: PropTypes.bool,
  profile: PropTypes.object.isRequired,
  bookingId: PropTypes.string,
  room: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  btnId: PropTypes.string,
};
ChatContact.defaultProps = {
  IAMBooker: false,
  IAMHoster: false,
  bookingId: undefined,
  onClick: () => {},
  btnId: '',
};

export default withStyles(styles)(ChatContact);
